import React from 'react';
import PropTypes from 'prop-types';
import { get } from './Storage';
import * as Colors from 'material-ui/styles/colors';
import { ClassName, Base64 } from 'mgToolsKit';
import axios from 'axios';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import { GridList, GridTile } from 'material-ui/GridList';
import { Message } from "mgUiKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'CasinoGameComponent';

var styles = AppSettings.styles;

class CasinoGame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: false
        };
    }

    componentDidMount() {
       
    }

    handleOpen(){
       this.setState({open: true});
    }

    handleClose(){
        this.setState({open: false});
    }

    checkGame(game) {
        this.setState(
            {
                loading: true,
                error: false
            }
        );
        var url = AppSettings['env'].urlUserBoxGetCasinoGame.replace("[CODE]", game.GameCode);
        axios.get(url)
            .then(({ data, status, statusText }) => {

                if(data.errors.length == 0){
                    this.setState(
                        {
                            loading: false,
                            error: false
                        }
                    );
                    this.context.handlePlayCasinoGame(game);
                }
                else{
                    var error = data.errors[0];
                    this.setState(
                        {
                            loading: false,
                            error: true
                        });
                }
                /*
                if (data != null) {
                    this.setState(
                        {
                            loading: false,
                            error: false
                        }
                    );
                    this.context.handlePlayCasinoGame(game);
                    //this.playGame(game);
                }
                else {
                    this.setState(
                    {
                        loading: false,
                        error: true
                    }
                );
                }*/
            })
            .catch((error) => {
                this.setState(
                    {
                        loading: false,
                        error: true
                    }
                );
            });
    }
    
    render() {
        var game = this.props.game;
        var key = game.GameCode;
        var gameImg = "http://" + AppSettings["env"].casinoImgDomain + game.preview;
        var content = "";
        if(!this.state.loading){
            if(!this.state.error){
                content =  <img src={gameImg} onClick={this.checkGame.bind(this, game)} />;
            }
            else{
                content =  <Message type="warning">Non disponibile</Message>;
            }
        }
        else{
            content = <RefreshIndicator
                        size={25}
                        left={30}
                        top={25}
                        status="loading"
                        style={{position: "absolute"}}
                    />;
        }
      
        return (
            <GridTile
                className="promo-casino-game-item"
                key={key}
            //title={game.GameName} 
            //titleStyle={styles.fontSize11}
            //titlePosition="top"
            >
            {content}
            </GridTile>
        );
    }
}

CasinoGame.displayName = componentName;

// PropTypes validation
CasinoGame.propTypes = {
    game: PropTypes.object.isRequired
};

// default props
CasinoGame.defaultProps = {};

// contextTypes validation
CasinoGame.contextTypes = {
}

CasinoGame.contextTypes = {
    handlePlayCasinoGame: PropTypes.func
}

export default  CasinoGame;